import * as React from 'react';
import { withStyles } from 'tss-react/mui';
import EDPanel from '../../../BaseComponents/Panel/EDPanel';
import EDLinkList from '../../../BaseComponents/List/LinkList/EDLinkList';
import EDLinkListItem from '../../../BaseComponents/List/LinkList/EDLinkListItem';
import EDTabs from '../../../BaseComponents/Tabs/EDTabs';
import EDTab from '../../../BaseComponents/Tabs/Tab/EDTab';
import EDIcon from '../../../BaseComponents/Icon/EDIcon';
import {
  rapportRouteName,
  rutinRouteName,
  styrvardeRouteName,
} from '../../../Features/Routing/router';
import { IRutinInfo } from '../../../Types/RutinInfoType';
import { IDelsystem } from '../_Common/Const/Delsystem';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';
import AvailableRutinerInDelsystem from '../../../Components/QueryComponents/AvailableRoutinesQuery/AvailableRutinerInDelsystem';
import AvailableStyrvardenInDelsystem from '../../../Components/QueryComponents/AvailableRoutinesQuery/AvailableStyrvardenInDelsystem';
import AvailableRapporterInDelsystem from '../../../Components/QueryComponents/AvailableRoutinesQuery/AvailableRapporterInDelsystem';
import { IRapportInfo } from '../../../Types/RapportInfoType';
import { rapporter } from '../_Common/Const/Rapporter';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router';
import {
  currentRoutingVersion,
  useBaseRouteValue,
} from '../../Routing/Utils/routerUtils';
import EDBox from '../../../BaseComponents/EDBox/EDBox';

interface IProps {
  delsystem: IDelsystem;
  dbName?: string;
  tab?: number;
  rapportID?: string;
  classes?: any;
}

const styles = {
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '1em',
    paddingBottom: '1em',
  },
  contentTitle: {
    padding: '24px 24px 0',
  },
  contentImg: {
    verticalAlign: 'text-top',
    width: '204px',
    margin: '0 16px 0 24px',
  },
};

export const DelsystemOversikt: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const navigate = useNavigate();
  const location = useLocation();

  const { databasePath, systemPath, usernamePath } = useBaseRouteValue();

  const setTab = (value: number) => {
    navigate(
      location.pathname.replace(
        new RegExp(props.delsystem.path + '.*$'),
        props.delsystem.path +
          '/' +
          (value === 1
            ? styrvardeRouteName
            : value === 2
            ? rapportRouteName
            : '')
      ),
      { replace: true }
    );
  };

  const RapportComp = props.rapportID
    ? rapporter[props.rapportID].component
    : undefined;

  return (
    <div className={props.classes.root}>
      <EDPanel width="50%" contentPadding="none">
        <div
          style={{
            backgroundColor: props.delsystem.brandingColor,
            color: props.delsystem.brandingColorText,
          }}
        >
          <EDTypography
            variant="h4"
            color="inherit"
            className={props.classes.contentTitle}
          >
            <img
              src={props.delsystem.branding}
              alt="delsystem-ikon"
              className={props.classes.contentImg}
            />
            {props.delsystem.benamning}
          </EDTypography>
          <EDTabs
            value={props.tab || 0}
            onChange={setTab}
            style={{
              backgroundColor: props.delsystem.brandingColorDark,
              color: props.delsystem.brandingColorText,
              width: '100%',
            }}
            indicatorColor="white"
          >
            <EDTab
              label="Rutiner"
              style={{ flex: '1 1 auto' }}
              testId="tab-rutiner"
            />
            <EDTab
              label="STYRVÄRDEN"
              style={{ flex: '1 1 auto' }}
              testId="tab-styrvärden"
            />
            <EDTab
              label="RAPPORTER"
              style={{ flex: '1 1 auto' }}
              testId="tab-rapporter"
            />
          </EDTabs>
        </div>
        <EDBox sx={{ height: 'calc(100vh - 320px)', overflowY: 'auto' }}>
          {(props.tab || 0) === 0 && (
            <AvailableRutinerInDelsystem
              delsystem={props.delsystem}
              dbName={props.dbName}
            >
              {availableRoutines => {
                return (
                  <EDLinkList>
                    {availableRoutines.map((x: IRutinInfo) => (
                      <EDLinkListItem
                        key={x.rutinKod}
                        to={`/${currentRoutingVersion}/${systemPath}/${usernamePath}/${databasePath}/${rutinRouteName}/${x.rutinURL}`}
                        text={x.benamning}
                        icon={<EDIcon iconType="exit_to_app" />}
                        testId={`linkListItem-${x.benamning}`}
                      />
                    ))}
                  </EDLinkList>
                );
              }}
            </AvailableRutinerInDelsystem>
          )}
          {props.tab === 1 && (
            <AvailableStyrvardenInDelsystem
              delsystem={props.delsystem}
              dbName={props.dbName}
            >
              {availableStyrvarden => (
                <EDLinkList>
                  {availableStyrvarden.map((x: IRutinInfo) => (
                    <EDLinkListItem
                      key={x.rutinKod}
                      to={`/${currentRoutingVersion}/${systemPath}/${usernamePath}/${databasePath}/${styrvardeRouteName}/${x.rutinURL}`}
                      text={x.benamning}
                      icon={<EDIcon iconType="exit_to_app" />}
                      testId={`linkListItem-${x.benamning}`}
                    />
                  ))}
                </EDLinkList>
              )}
            </AvailableStyrvardenInDelsystem>
          )}
          {props.tab === 2 && (
            <AvailableRapporterInDelsystem
              delsystem={props.delsystem}
              dbName={props.dbName}
            >
              {availableRapporter => (
                <EDLinkList>
                  {availableRapporter.map((x: IRapportInfo) => (
                    <EDLinkListItem
                      key={x.rapportID}
                      to={`${x.rapportID}`}
                      text={x.benamning}
                      icon={<EDIcon iconType="exit_to_app" />}
                      testId={`linkListItem-${x.benamning}`}
                    />
                  ))}
                </EDLinkList>
              )}
            </AvailableRapporterInDelsystem>
          )}
        </EDBox>
      </EDPanel>

      {RapportComp && <RapportComp />}
    </div>
  );
};

export default withStyles(DelsystemOversikt, styles);
